(function () {
    var CART = (window.__calRefSyncCart || { _oppref: '', _obref: '', item_count: 0 });
    var LOG_PREFIX = '[openai-ref-sync]';
    var POLL_INTERVAL_MS = 1000; // fallback watcher, only when the Cookie Store API is missing
    var DEBOUNCE_MS = 150; // a cookie rewrite fires delete + set back to back

    /* ------------------------------------------------------------------
       Cookie name → cart attribute key.

       The cookies are named with a double underscore, but the cart
       attributes must NOT be: Shopify treats a `__`-prefixed cart
       attribute as PRIVATE — it is stored, yet never returned by the
       Ajax API (/cart.js) or Liquid's cart.attributes. /cart/update.js
       still echoes it back in its response, so the write looks fine and
       the value is invisible on the very next read.

       Changing an attribute key here means changing the Liquid block at
       the top of this snippet too.
    ------------------------------------------------------------------ */
    var REFS = [
      { cookie: '__oppref', attribute: '_oppref' },
      { cookie: '__obref', attribute: '_obref' }
    ];

    // Debug is ON by default. Silence it with ?refsync_debug=0 or
    // localStorage.setItem('refsync_debug', '0') — re-enable with '1'.
    var DEBUG = (function () {
      try {
        var param = new URLSearchParams(window.location.search).get('refsync_debug');
        if (param !== null) {
          localStorage.setItem('refsync_debug', param);
          return param !== '0';
        }
        return localStorage.getItem('refsync_debug') === '1';
      } catch (e) {
        return true;
      }
    })();

    // Per-run switch: revalidation passes stay quiet unless they find drift.
    var verbose = true;

    function log() {
      if (!DEBUG) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift(LOG_PREFIX);
      console.log.apply(console, args);
    }

    function warn() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(LOG_PREFIX);
      console.warn.apply(console, args);
    }

    function table(title, rows) {
      if (!DEBUG || !verbose || !rows.length) return;
      if (console.table) {
        console.log(LOG_PREFIX + ' ' + title);
        console.table(rows);
      } else {
        log(title, rows);
      }
    }

    // Cart attribute values as of the last time we knew them: rendered
    // server-side by Liquid, then kept current from each update response.
    var knownCart = {
      _oppref: CART._oppref,
      _obref: CART._obref
    };

    var COOKIE_NAMES = REFS.map(function (ref) {
      return ref.cookie;
    });
    var HOST = window.location.hostname.toLowerCase();

    // Catch a REFS entry that the Liquid block above was never updated for,
    // and any attribute key Shopify would quietly make private.
    function checkConfig() {
      REFS.forEach(function (ref) {
        if (ref.attribute.indexOf('__') === 0) {
          warn(
            'cart attribute "' + ref.attribute + '" starts with "__", which Shopify treats as a ' +
              'PRIVATE attribute: it is stored but never returned by /cart.js or Liquid ' +
              'cart.attributes, so this script can never confirm it. Use a single underscore.'
          );
        }
        if (!(ref.attribute in knownCart)) {
          warn(
            'cart attribute "' + ref.attribute + '" has no server-rendered value — add it to the ' +
              'Liquid block at the top of this snippet, or every page load will look like drift.'
          );
          knownCart[ref.attribute] = '';
        }
      });
    }

    /* ------------------------------------------------------------------
       Reading cookies

       Two different cookies can look like "obref":
         1. A different name that merely contains it (e.g. `_obref` set by
            another script) — handled by matching the name EXACTLY.
         2. The same name set on a different domain scope (another site
            under a shared parent domain, or a broader `.domain` cookie) —
            document.cookie hides the domain, so we use the Cookie Store
            API where available to pick the one scoped to THIS host.
    ------------------------------------------------------------------ */

    function parseDocumentCookie() {
      var out = [];
      if (!document.cookie) return out;
      document.cookie.split(';').forEach(function (part) {
        var raw = part.trim();
        var eq = raw.indexOf('=');
        if (eq < 1) return;
        out.push({
          name: raw.slice(0, eq),
          value: raw.slice(eq + 1)
        });
      });
      return out;
    }

    // Fallback source: no domain/path visibility, browser-ordered.
    function candidatesFromDocument(name) {
      return parseDocumentCookie()
        .filter(function (c) {
          return c.name === name; // exact — '_obref' never matches '__obref'
        })
        .map(function (c) {
          return {
            value: decodeURIComponent(c.value),
            domain: undefined,
            path: undefined,
            source: 'document.cookie'
          };
        });
    }

    // Preferred source: exposes domain + path so we can tell ours apart.
    function candidatesFromStore(name) {
      if (!window.cookieStore || !window.cookieStore.getAll) {
        return Promise.resolve(null);
      }
      return window.cookieStore
        .getAll({ name: name })
        .then(function (list) {
          return list
            .filter(function (c) {
              return c.name === name;
            })
            .map(function (c) {
              return {
                value: c.value,
                domain: c.domain, // null for host-only cookies
                path: c.path,
                source: 'cookieStore'
              };
            });
        })
        .catch(function (err) {
          log('cookieStore unavailable for "' + name + '", falling back:', err);
          return null;
        });
    }

    // How likely is this cookie ours? Higher rank = tighter scope = ours.
    function scopeOf(candidate) {
      if (candidate.source !== 'cookieStore') {
        return { ours: null, rank: 1, depth: 0, label: 'unknown (no domain info)' };
      }
      if (!candidate.domain) {
        // Host-only cookie: set by this exact host, cannot be another site.
        return { ours: true, rank: 3, depth: HOST.split('.').length, label: 'host-only ' + HOST };
      }
      var domain = String(candidate.domain).replace(/^\./, '').toLowerCase();
      if (domain === HOST) {
        return { ours: true, rank: 3, depth: domain.split('.').length, label: domain };
      }
      if (HOST.length > domain.length && HOST.slice(-(domain.length + 1)) === '.' + domain) {
        // Parent-domain cookie — readable here, but shared with sibling sites.
        return { ours: true, rank: 2, depth: domain.split('.').length, label: '.' + domain + ' (shared)' };
      }
      return { ours: false, rank: 0, depth: 0, label: domain + ' (NOT this site)' };
    }

    // Most specific scope wins; ties broken by path length, then browser order.
    function pickOurs(name, candidates) {
      var ranked = candidates
        .map(function (c, i) {
          return { candidate: c, scope: scopeOf(c), index: i };
        })
        .sort(function (a, b) {
          return (
            b.scope.rank - a.scope.rank ||
            b.scope.depth - a.scope.depth ||
            String(b.candidate.path || '').length - String(a.candidate.path || '').length ||
            a.index - b.index
          );
        });

      var mine = ranked.filter(function (r) {
        return r.scope.ours !== false;
      });
      var foreign = ranked.filter(function (r) {
        return r.scope.ours === false;
      });

      if (foreign.length) {
        warn(
          'ignoring ' + foreign.length + ' cookie(s) named "' + name + '" from another site:',
          foreign.map(function (r) {
            return r.scope.label + ' = ' + r.candidate.value;
          })
        );
      }

      var distinct = {};
      mine.forEach(function (r) {
        distinct[r.candidate.value] = true;
      });
      if (Object.keys(distinct).length > 1) {
        warn(
          'multiple cookies named "' + name + '" with different values — using the most specific scope (' +
            mine[0].scope.label + ')'
        );
      }

      table('cookie candidates for "' + name + '"', ranked.map(function (r) {
        return {
          value: r.candidate.value,
          scope: r.scope.label,
          path: r.candidate.path === undefined ? '(unknown)' : r.candidate.path,
          source: r.candidate.source,
          used: mine.length > 0 && r === mine[0] ? '← ours' : ''
        };
      }));

      return mine.length ? mine[0].candidate.value : null;
    }

    function readCookie(name) {
      return candidatesFromStore(name).then(function (fromStore) {
        var candidates = fromStore;
        if (!candidates) {
          candidates = candidatesFromDocument(name);
          if (candidates.length > 1) {
            warn(
              'browser has no Cookie Store API, so the domain of each "' + name +
                '" cookie is invisible here — ' + candidates.length +
                ' were found and the browser-preferred one is used'
            );
          }
        }
        if (!candidates.length) return null;
        return pickOurs(name, candidates);
      });
    }

    function readAllCookies() {
      return Promise.all(COOKIE_NAMES.map(readCookie)).then(function (values) {
        var out = {};
        COOKIE_NAMES.forEach(function (name, i) {
          out[name] = values[i];
        });
        return out;
      });
    }

    // Names that merely look like ours — logged so collisions are obvious.
    function logLookAlikes() {
      if (!DEBUG) return;
      var stems = COOKIE_NAMES.map(function (name) {
        return name.replace(/^_+/, '').toLowerCase();
      });
      var lookAlikes = parseDocumentCookie().filter(function (c) {
        if (COOKIE_NAMES.indexOf(c.name) !== -1) return false;
        var lower = c.name.toLowerCase();
        return stems.some(function (stem) {
          return lower.indexOf(stem) !== -1;
        });
      });
      table('look-alike cookies (ignored — name is not an exact match)', lookAlikes.map(function (c) {
        return { name: c.name, value: decodeURIComponent(c.value) };
      }));
    }

    /* ------------------------------------------------------------------
       Syncing — cookies are the source of truth while they exist. A
       deleted cookie never clears an attribute already on the cart.
    ------------------------------------------------------------------ */

    var syncing = false;
    var queued = null; // { reason, options } of a sync requested mid-flight
    var debounceTimer = null;
    var readCounter = 0; // cache-buster for the verification read

    // /cart/update.js echoes back whatever it was sent, so it cannot prove
    // an attribute persisted. Only a fresh /cart.js read can.
    function verifyPersisted(attributeKeys) {
      return fetch('/cart.js?refsync=' + ++readCounter, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status + ' ' + res.statusText);
          return res.json();
        })
        .then(function (cart) {
          var attrs = cart.attributes || {};
          log('re-read /cart.js — item count:', cart.item_count, '| attributes:', attrs);
          var missing = attributeKeys.filter(function (key) {
            return !attrs[key];
          });
          if (!missing.length) {
            log('✔ persisted in /cart.js:', attributeKeys.join(', '));
            return;
          }
          warn(
            '✘ ' + missing.join(', ') + ' updated successfully but absent from /cart.js. ' +
              'A key beginning with "__" is a Shopify private attribute (stored, never readable); ' +
              'otherwise another script is clearing cart attributes after us.'
          );
        })
        .catch(function (err) {
          warn('/cart.js verification read failed:', err);
        });
    }

    function sync(reason, options) {
      var quiet = !!(options && options.quiet);

      if (syncing) {
        queued = { reason: reason, options: options }; // keep its own verbosity
        log('sync in flight — queued follow-up for:', reason);
        return Promise.resolve();
      }

      syncing = true;
      verbose = DEBUG && !quiet;
      if (verbose) log('sync start —', reason);

      return readAllCookies()
        .then(function (cookies) {
          var changed = {};
          var report = [];

          REFS.forEach(function (ref) {
            var cookieValue = cookies[ref.cookie];
            var attrValue = knownCart[ref.attribute];
            var action;

            if (!cookieValue) {
              action = 'skip — no cookie of ours set';
            } else if (cookieValue === attrValue) {
              action = 'skip — already in sync';
            } else {
              action = attrValue ? 'update — cookie differs from cart' : 'update — cart attribute empty';
              changed[ref.attribute] = cookieValue;
            }

            report.push({
              cookie: ref.cookie,
              cookieValue: cookieValue,
              cartAttribute: ref.attribute,
              cartValue: attrValue,
              action: action
            });
          });

          if (!Object.keys(changed).length) {
            table('cookie vs cart attribute', report);
            if (verbose) log('nothing to sync — cart attributes match cookies');
            return;
          }

          verbose = DEBUG; // drift found: say something even on a quiet pass
          table('cookie vs cart attribute', report);
          log('POST /cart/update.js with attributes:', changed);

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: changed })
          })
            .then(function (res) {
              log('response status:', res.status, res.statusText);
              if (!res.ok) {
                throw new Error('HTTP ' + res.status + ' ' + res.statusText);
              }
              return res.json();
            })
            .then(function (cart) {
              log('cart attributes echoed by update:', cart.attributes);
              var applied = [];
              Object.keys(changed).forEach(function (key) {
                var value = cart.attributes && cart.attributes[key];
                if (value === changed[key]) {
                  knownCart[key] = value; // keep later comparisons honest
                  applied.push(key);
                } else {
                  warn('✘ ' + key + ' did not stick — expected:', changed[key], 'got:', value);
                }
              });
              if (!applied.length) return;
              log('accepted by update:', applied.join(', '), '— verifying against /cart.js');
              return verifyPersisted(applied);
            });
        })
        .catch(function (err) {
          warn('cart attribute sync failed (' + reason + '):', err);
        })
        .then(function () {
          syncing = false;
          if (queued) {
            var next = queued;
            queued = null;
            return sync(next.reason, next.options);
          }
        });
    }

    function scheduleSync(reason, options) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        sync(reason, options);
      }, DEBOUNCE_MS);
    }

    /* ------------------------------------------------------------------
       Watching for cookie changes after page load — the referral cookie
       can be written late (redirect hop, app script, another tab).
    ------------------------------------------------------------------ */

    // Native change events, Chromium-based browsers. A cookie rewritten with
    // the value already on the cart is dropped here, so no sync pass runs.
    function watchViaCookieStore() {
      if (!window.cookieStore || !window.cookieStore.addEventListener) return false;
      window.cookieStore.addEventListener('change', function (event) {
        var actionable = []; // a value we have not put on the cart yet
        var ignored = []; // same value, or another site's cookie
        var removed = []; // gone — may expose a duplicate we now prefer

        (event.changed || []).forEach(function (c) {
          var i = COOKIE_NAMES.indexOf(c.name);
          if (i === -1) return;
          var scope = scopeOf({
            value: c.value,
            domain: c.domain,
            path: c.path,
            source: 'cookieStore'
          });
          if (scope.ours === false) {
            ignored.push(c.name + ' belongs to ' + scope.label);
          } else if (c.value === knownCart[REFS[i].attribute]) {
            ignored.push(c.name + ' unchanged (' + c.value + ')');
          } else {
            actionable.push('set ' + c.name + '=' + c.value + ' [' + scope.label + ']');
          }
        });

        (event.deleted || []).forEach(function (c) {
          if (COOKIE_NAMES.indexOf(c.name) !== -1) removed.push(c.name);
        });

        if (ignored.length) log('cookie change ignored —', ignored.join('; '));

        if (actionable.length) {
          log('cookie change:', actionable.join(', '));
          scheduleSync('cookie change: ' + actionable.join(', '));
        } else if (removed.length) {
          // Never clears an attribute, but a remaining duplicate in another
          // scope can now be the one we pick — so revalidate silently.
          log('cookie removed —', removed.join(', '), '— revalidating quietly');
          scheduleSync('cookie removed: ' + removed.join(', '), { quiet: true });
        }
      });
      log('watching cookies via cookieStore change events');
      return true;
    }

    // Fallback: poll the raw values of just our cookies (duplicates included).
    function snapshot() {
      return parseDocumentCookie()
        .filter(function (c) {
          return COOKIE_NAMES.indexOf(c.name) !== -1;
        })
        .map(function (c) {
          return c.name + '=' + c.value;
        })
        .join('; ');
    }

    function watchViaPolling() {
      var last = snapshot();
      setInterval(function () {
        if (document.hidden) return; // visibilitychange picks it up on return
        var now = snapshot();
        if (now === last) return;
        log('cookie poll detected a change:', last || '(none)', '→', now || '(none)');
        last = now;
        scheduleSync('cookie poll');
      }, POLL_INTERVAL_MS);
      log('watching cookies by polling every ' + POLL_INTERVAL_MS + 'ms (no cookieStore API)');
    }

    // Quiet revalidation for the gaps a watcher can miss: a cookie written
    // while the tab was hidden, or the page restored from the back cache.
    function watchLifecycleEvents() {
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) scheduleSync('tab became visible', { quiet: true });
      });
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) scheduleSync('restored from back/forward cache', { quiet: true });
      });
    }

    /* ------------------------------------------------------------------ */

    checkConfig();
    log('cookie → cart attribute:', REFS.map(function (r) {
      return r.cookie + ' → ' + r.attribute;
    }).join(', '));
    log('cart attributes (server-rendered):', knownCart);
    log('cart item count:', CART.item_count);
    log('host:', HOST, '| cookieStore API:', !!(window.cookieStore && window.cookieStore.getAll));
    logLookAlikes();

    if (!watchViaCookieStore()) watchViaPolling();
    watchLifecycleEvents();

    // Manual handle for debugging from the console.
    window.openaiRefSync = {
      sync: function (reason) {
        return sync(reason || 'manual console call');
      },
      readCookies: readAllCookies,
      cartAttributes: function () {
        return knownCart;
      },
      verify: function () {
        return verifyPersisted(REFS.map(function (r) {
          return r.attribute;
        }));
      },
      refs: REFS
    };

    sync('initial page load');
  })();
